export default __webpack_public_path__ + "static/media/downarrow.dc0da806.svg";